<template>
    <div class="fhv-centent"  v-loading="loading" >
        <h4 class="title-topic">MAC Filtering</h4>
            <el-form :model="From"
             :rules="rules"
            ref="forms" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable:" >
                 <el-switch v-model="flag" @change="setMacfilterEnable"></el-switch>
            </el-form-item>
            <div v-if="flag">
                <el-form-item label="Filter Mode:" >
                    <el-radio v-model="From.radio" label="0" @change="changeTab">Blacklist</el-radio>
                    <el-radio v-model="From.radio" label="1" @change="changeTab">Whitelist</el-radio>
                </el-form-item>
                <el-form-item label="SMAC Address:" prop="address">
                    <el-input v-model="From.address"></el-input>
                </el-form-item>
                <el-form-item label="TMAC Address:" v-if="From.flag">
                    <el-input v-model="From.Taddress"></el-input>
                </el-form-item>
                <el-form-item label="Comment:" >
                    <el-input v-model="From.comment"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="add">Add</el-button>
                </el-form-item>
            </div>
            
           

        </el-form>
        <h4 v-text="text">Current Blacklist MAC Table:</h4>
         <el-table :data="tableData" stripe style="width: 100%" border class="fhv-table">
            <el-table-column prop="address" label="SMAC Address" ></el-table-column>
            <el-table-column prop="comment" label="Comment"></el-table-column>
            <el-table-column prop="index" label="Select">
                  <template slot-scope="scope">
                    <el-button
                        @click.native.prevent="deleteRow(scope.row.index, tableData)"
                        type="text"
                        size="small">
                        Delete
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
  data() {
    return {
      text: "Current Blacklist MAC Table:",
      loading: false,
      flag: false,
      From: {
        flag: false,
        address: "",
        Taddress: "",
        comment: "",
        radio: "1"
      },
      tableData: [],
      rules: {
        address: [
          {
            validator: (rule, value, callback) => {
              if (!validator.isMACAddress(value)) {
                callback(
                  new Error("MAC Address Error! e.g 00:0E:C6:DE:C7:99!")
                );
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    

    deleteRow(index, rows) {
      this.del(index);
    },
    del(index) {
      let postData = {}
      if (index == "all") {
        postData = {
          Delete_All: "Delete All",
          submit_url: "/macfilter.htm"
        };
      } else {
        postData = {
          deleteSelFilterMac: "Delete Selected",
          "submit-url": "/macfilter.htm"
        };
        var name = `select${index}`;
        postData[name] = "ON";
      }
      this.loading = true;
      axios.post("/boafrm/setformFilter", postData).then(res => {
        this.loading = false;
        this.$message.success(res.data.msg);
        this.getData();
      });
    },
    getData() {
      this.loading = true;
      axios.post("/boafrm/getMacFilterStatus").then(res => {
        this.loading = false;
       
        if (res.data.macFilterEnabled === '1') {
          this.flag = true;
        }
        this.From.radio = res.data.macFilterMode;
        if (this.From.radio == 0) {
          this.getBlackList();
        } else {
          this.getWihteList();
        }
      });
    },
    getBlackList() {
      this.loading = true;
      axios.post("/boafrm/getMacBlackStatus").then(res => {
        this.loading = false;
        let data = res.data;
        this.blackData = data;
        this.tableData = [];
        this.text = "Current Blacklist MAC Table:";
        for (var i = 0; i < data.BlackList.length - 1; i++) {
          if (data.BlackList[i].tmac != undefined) {
            this.From.flag = true;
            this.tableData.push({
              address: data.BlackList[i].smac,
              Taddress: data.BlackList[i].tmac,
              comment: data.BlackList[i].comment,
              index: data.BlackList[i].index
            });
          } else {
            this.From.flag = false;
            this.tableData.push({
              address: data.BlackList[i].smac,
              comment: data.BlackList[i].comment,
              index: data.BlackList[i].index
            });
          }
        }
      });
    },
    getWihteList() {
      this.loading = true;
      axios.post("/boafrm/getMacWhiteStatus").then(res => {
        this.loading = false;
        let data = res.data;
        this.whiteData = data;
        this.tableData = [];
        this.text = "Current Whitelist MAC Table:";
        for (var i = 0; i < data.whiteList.length - 1; i++) {
          if (data.whiteList[i].tmac != undefined) {
            this.From.flag = true;
            this.tableData.push({
              address: data.whiteList[i].smac,
              Taddress: data.whiteList[i].tmac,
              comment: data.whiteList[i].comment,
              index: data.whiteList[i].index
            });
          } else {
            this.From.flag = false;
            this.tableData.push({
              address: data.whiteList[i].smac,
              comment: data.whiteList[i].comment,
              index: data.whiteList[i].index
            });
          }
        }
      });
    },
    changeTab() {
      let postData = {}
      if (this.From.radio == 0) {
        postData = {
          enabled: this.flag == true ? "ON" : "",
          macFilterMode: "0",
          "submit-url": "/macfilter.htm",
          addFilterMacFlag: "1"
        };
        this.loading = true;
        axios.post("/boafrm/setformFilter", postData).then(res => {
          this.loading = false;
          this.$message.success(res.data.msg);
          this.text = "Current Blacklist MAC Table:";
          this.getBlackList();
        });
      } else {
        postData = {
          enabled: this.flag == true ? "ON" : "",
          macFilterMode: "1",
          "submit-url": "/macfilter.htm",
          addFilterMacFlag: "1"
        };
        this.loading = true;
        axios.post("/boafrm/setformFilter", postData).then(res => {
          this.loading = false;
          this.$message.success(res.data.msg);
          this.text = "Current Whitelist MAC Table:";
          this.getWihteList();
        });
      }
    },
    add() {
      let postData = {}
      if (this.From.flag == false) {
        postData = {
          enabled: this.flag == true ? "ON" : "",
          macFilterMode: this.From.radio,
          "submit-url": "/macfilter.htm",
          addFilterMacFlag: "1",
          addFilterMac: "Save",
          mac: this.From.address,
          comment: this.From.comment
        };
      } else {
        postData = {
          enabled: this.flag == true ? "ON" : "",
          macFilterMode: this.From.radio,
          "submit-url": "/macfilter.htm",
          addFilterMacFlag: "1",
          addFilterMac: "Save",
          mac: this.From.address,
          comment: this.From.comment,
          dmac: this.From.Taddress
        };
      }
      
      if (postData.mac == "" && postData.comment == ""&& !this.flag) {
        this.loading = true;
        axios.post("/boafrm/setformFilter", postData).then(res => {
          this.loading = false;
          this.getData();
        });
        return;
      }
      this.$refs['forms'].validate((valid) => {
          console.log(valid);
          if(valid)
          {
              this.loading = true;
              axios
              .post("/boafrm/setformFilter", postData)
              .then(res => {
                this.loading = false;
                if(res.data.result === 'ok')
                  this.$message.success(res.data.msg);
                else
                  this.$message.error(res.data.msg);
                this.getData();
              });
          }
          else 
          {
              console.log("submit error!");
              return false;
          }
          
      })
    
    },
    setMacfilterEnable(val){
        this.loading = true;
        axios
        .post("/JSONAPI", {
            cmdType:"SET_MACFILTER_ENABLE",
            macFilterEnable:val
        })
        .then(response => {
            this.loading = false;
            if(response.data.ret === 0)
                this.$message.success('Set MAC Filter Enbale success!')
            else
                this.$message.error(`Set MAC Filter Enbale failed! Error:${response.data.errMsg}`)
        });
    },
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.fhv-centent {
  h4 {
    margin-bottom: 15px;
  }
  .btn-contain {
    width: 500px;
  }
  @media (max-width: 768px) {
    .btn-contain{
            width: 100%;
           padding-left: 0;
     }
  }
}
</style>




